'use strict';

import './HowItWorks.less';

import React from 'react';
import lang from './HowItWorksLang';
import HowItWorksColumn from './HowItWorksColumn';
import PropTypes from 'prop-types';
import ReactCKImage from 'ck-core-client/source/ui/ReactCKImage';
import RoundButton from 'ck-core-client/source/ui/RoundButton';
import VideoModal from 'ck-core-client/source/components/Modal/Video';

export default class HowItWorks extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			isVideoModalOpen: false
		};
	}
	render() {
		const columns = [];

		lang[this.props.langKey].COLUMNS.forEach(columnLang => {
			columns.push(
				<HowItWorksColumn
					title={columnLang.TITLE}
					explanation={columnLang.EXPLANATION}
					animation={columnLang.ANIMATION}
					image={columnLang.IMAGE}
					key={columnLang.TITLE}
				/>
			);
		});

		return (
			<div className="HowItWorks">
				{this.state.isVideoModalOpen ? (
					<VideoModal
						videoId={this.state.videoId}
						onClose={() => this.setState({ isVideoModalOpen: false })}
					/>
				) : null}

				<ReactCKImage name="generic-white-cloud" extraClasses={['cloudLeft']} />
				<ReactCKImage name="generic-white-cloud" extraClasses={['cloudRight']} />

				<div className="maxWidthContentWrapper">
					<div className="centre">
						<h2 className="header">{lang.TITLE}</h2>
						<div className="columns row">{columns}</div>
					</div>
				</div>

				<div className="howItWorksButtons">
					<RoundButton
						buttonClass="watchVideo"
						handleClick={() =>
							this.setState({
								isVideoModalOpen: true,
								videoId: '169676431'
							})
						}
						text={'Watch demo'}
						colour="red"
						icon="button-play-icon"
						size="medium"
						hoverAnimation="hvr-bounce-in"
					/>
				</div>
			</div>
		);
	}
}

HowItWorks.propTypes = {
	langKey: PropTypes.string.isRequired
};
